import Component from './Component';
import { hasError, showError, removeError, handleEvents, focus } from './../services/FormValidation';
import { togglePreloader } from './../services/ScrollResizeHandler';
import axios from 'axios';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

 let newPromise;
 let qs = window.Questions;



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */






/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Questionnaire extends Component {

    decorator () {
        return {
            selector : '.js-questionnaire',
            name : 'Questionnaire',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        //focus(this.$fieldset[0].elements[0]);
        let els = this.getIEelements(this.$fieldset[0]);
        focus(els[0]);

        this.bindElements();
    }


    cacheElements () {
        this.$form = this.element.getElementsByTagName('form');
        this.$formElements = this.$form[0].elements;
        this.$fieldset = Array.from(this.$form[0].querySelectorAll('fieldset'));
        this._token = this.$formElements['_token'];
        this._displayed_content = this.$formElements['_displayed_content'];
        this._action = this.$form[0].getAttribute('action');
        this.$submit = this.element.querySelector('.js-questionnaire-submit');
    }


    bindElements () {

        this.$form[0].addEventListener('submit', e => {
            e.preventDefault();

            const fields = e.target.elements;

            let error,
                hasErrors;


            for (let i = 0; i < fields.length; i++) {
                error = hasError(fields[i]);

                if (error) {
                    showError(this.$formElements, fields[i], error);

                    if (!hasErrors) {
                        hasErrors = fields[i];
                    }
                }

                if (hasErrors) {
                    hasErrors.focus();
                }
            }

            if (typeof hasErrors != 'undefined') { return; }

            togglePreloader();

            this.sendDataTo(this._action, this._token.value, this._displayed_content.value);
        });


        handleEvents(this.$formElements);
    }



    sendDataTo (url, token, display_content) {
        const newContents = JSON.stringify(this.appendAnswer(this.$fieldset));

        newPromise = axios.post(url, {
                '_token': token,
                'link': qs.link,
                'selected_project': qs.project_id,
                'contents': newContents,
                '_displayed_content': display_content
            })
            .then(response => {
                if (response.status == 200 && response.data.success) {
                    window.location.href = response.data.url;
                }
            })
            .catch(error => {
                console.error(error);
            });
    }


    getIEelements (fieldset) {
        let elements = Array.from(fieldset.getElementsByTagName('input'));
        elements = elements.concat(Array.from(fieldset.getElementsByTagName('select')));
        elements = elements.concat(Array.from(fieldset.getElementsByTagName('textarea')));
        return elements;
    }


    appendAnswer (fieldset) {
        const qid = qs.question_id - 1;
        let fields;
        let selected = [];

        for (let i = 0; i < fieldset.length; i++) {
            fields = (typeof fieldset[i].elements === 'undefined') ? this.getIEelements(fieldset[i]) : fieldset[i].elements;

            for (let x = 0; x < fields.length; x++) {
                if (fields[x].type != 'submit' && fields[x].type != 'button' && fields[x].name != '_token' && !fields[x].classList.contains('no-submit')) {
                    if (typeof qs.question_id == 'undefined' || qs.question_id == 0) {
                        qs['answer_' + fields[x].name] = fields[x].value;
                    } else {
                        if (fields[x].type == 'radio' || fields[x].type == 'checkbox') {
                            if (fields[x].checked) {
                                selected.push(fields[x].value);
                                qs['questions'][qid]['fields'][i]['field']['answer'] = selected;
                            }
                        } else {
                            qs['questions'][qid]['fields'][i]['field']['answer'] = fields[x].value;
                        }
                    }
                }
            }
        }

        return qs;
    }

}
